export default __webpack_public_path__ + "static/media/admin_product_setting.97d4108c.svg";